import { render, staticRenderFns } from "./T1Forecasts.vue?vue&type=template&id=4faff13a&scoped=true&"
import script from "./T1Forecasts.vue?vue&type=script&lang=js&"
export * from "./T1Forecasts.vue?vue&type=script&lang=js&"
import style0 from "./T1Forecasts.vue?vue&type=style&index=0&id=4faff13a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faff13a",
  null
  
)

export default component.exports